var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#21A921",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.301 45.086a4.064 4.064 0 00-2.88-1.191 4.068 4.068 0 00-2.88 1.19 4.079 4.079 0 000 5.762l14.227 14.228a4.08 4.08 0 005.761 0L70.46 38.144a4.08 4.08 0 000-5.761 4.082 4.082 0 00-5.76 0l-24.05 24.05L29.3 45.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 4C23.29 4 4 23.29 4 47s19.29 43 43 43 43-19.29 43-43S70.71 4 47 4m0 90C21.084 94 0 72.916 0 47S21.084 0 47 0s47 21.084 47 47-21.084 47-47 47"
  }))));
}
export default __webpack_public_path__ + "success_icon.4bc99f37.svg";
export { SvgSuccessIcon as ReactComponent };